"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelCropParameter = exports.CollectionModelCropParameterMutator = void 0;
var cropParameter_state_1 = require("./cropParameter.state");
var CollectionModelCropParameterMutator = /** @class */ (function () {
    function CollectionModelCropParameterMutator(cropParameter) {
        this.cropParameter = cropParameter;
    }
    CollectionModelCropParameterMutator.prototype.setValue = function (state) {
        this.cropParameter.collectionState.setFieldValue(this.cropParameter.instanceId, state);
    };
    /** Gives a shallow clone of the crop correction state */
    CollectionModelCropParameterMutator.prototype.getValue = function () {
        return Object.assign({}, this.cropParameter.state);
    };
    /**
     * Remove the state of this crop correction
     * *Warning:* You will need to unlink & remove the crop correction from the list before destroying the state.
     * @see CollectionModelCropParameterStateMutator.remove
     */
    CollectionModelCropParameterMutator.prototype.destroyState = function () {
        this.cropParameter.collectionState.setFieldValue(this.cropParameter.instanceId, null);
    };
    /**
     * Remove the crop correction,
     * This will unlink and destroy the crop correction and all associated values.
     *
     * @see CollectionModelCropParameterStateMutator.remove
     */
    CollectionModelCropParameterMutator.prototype.remove = function () {
        this.cropParameter.cropParameterState.Mutator.remove(this.cropParameter);
    };
    return CollectionModelCropParameterMutator;
}());
exports.CollectionModelCropParameterMutator = CollectionModelCropParameterMutator;
var CollectionModelCropParameter = /** @class */ (function () {
    function CollectionModelCropParameter(state, cropParameterId, captureId) {
        this.instanceId = cropParameter_state_1.CollectionModelCropParameterState.cropParameterId(captureId, cropParameterId);
        this.id = cropParameterId;
        this.captureId = captureId;
        this.cropParameterState = state;
    }
    Object.defineProperty(CollectionModelCropParameter.prototype, "state", {
        get: function () {
            return this.collectionState.getFieldValue(this.instanceId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelCropParameter.prototype, "collectionState", {
        get: function () {
            return this.cropParameterState.collection.state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelCropParameter.prototype, "isDeletable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return CollectionModelCropParameter;
}());
exports.CollectionModelCropParameter = CollectionModelCropParameter;
//# sourceMappingURL=cropParameter.js.map